import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — Fitness Calculator" description="The page you're looking for doesn't exist." path="/404" />
      <div className="mx-auto max-w-2xl px-4 py-24 text-center">
        <p className="text-sm font-medium text-muted-foreground">404</p>
        <h1 className="mt-2 text-4xl font-bold">This page took a rest day.</h1>
        <p className="mt-3 text-muted-foreground">The calculator or page you're looking for doesn't exist — but we have 32 more waiting.</p>
        <Link
          to="/"
          data-testid="back-home"
          className="mt-8 inline-flex items-center rounded-full bg-primary text-primary-foreground px-5 h-11 text-sm font-medium hover:bg-foreground/85 transition"
        >
          Browse all calculators
        </Link>
      </div>
    </>
  );
}
